// import HeaderSearchInputIcon from "@gaiaherbs/Icons/HeaderSearchInputIcon";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { searchInputStyles } from "@insite/content-library/Widgets/Header/HeaderSearchInput";
import { css } from "styled-components";

searchInputStyles.searchInputStyles = mergeToNew(searchInputStyles.searchInputStyles, {
    input: {
        css: css`
            background: white !important;
            border: 2px solid #e5e1e6 !important;
            border-radius: 10px !important;
        `,
        cssOverrides: {
            formInputWrapper: css`
                button[class^="StyledButton"] {
                    width: 90px;
                    background: #79242f;
                    border-top-right-radius: 10px;
                    border-bottom-right-radius: 10px;
                    color: #fff;
                    justify-content: center;
                }
                button[class^="StyledButton"] span[class^="IconWrapper"] {
                    border-radius: 0px 8px 8px 0px;
                    width: 100%;
                    padding: 0px;
                    color: white;
                }
                span[class^="VisuallyHiddenStyle"] {
                    position: relative !important;
                    height: auto !important;
                    width: auto !important;
                    margin: 0 !important;
                    clip-path: none !important;
                }
            `,
            formField: css`
                width: 100%;
            `,
        },
    },
    popoverContentBody: {
        css: css`
            position: absolute !important;
            top: 50px !important;
            left: 0px !important;
            width: fit-content;
            overflow: auto;
        `,
    },
});
